<template>
  <section>
    <h1 class="section-head">จัดการลูกค้า</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <b-button type="is-success" tag="router-link" to="customer/add" v-can="'add_customer'" icon-left="plus">เพิ่ม</b-button>
          </div>
        </div>
      </div>
    </nav>

    <b-table 
      :data="filteredData"
      selectable
      @click="selected"
      :columns="columns"
      :selected.sync="selectedItem"
      ref="loadingElement"

      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :narrowed="true"
      @page-change="onPageChange"
    >
    </b-table>

    <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
    <div class="notification has-text-centered" v-if="((all_customer.length == 0) || !all_customer) && !isLoading">ไม่พบข้อมูล</div>
  </section>
</template>

<script>
  import Request from '@/libraries/request'

  export default {
    name: 'Product',
    data() {
      return {
        all_customer: [],
        columns: [{
            field: 'id',
            label: 'ID',
            width: '40',
            numeric: true
          },
          {
            field: 'name',
            label: 'Customer Name',
          },
          {
            field: 'type',
            label: 'ประเภทลูกค้า',
          },
          {
            field: 'address',
            label: 'Address'
          },
          {
            field: 'phone',
            label: 'Phone',
          },
          {
            field: 'email',
            label: 'E-mail',
          }
        ],
        selectedItem: {},
        lastSelected: {},
        isLoading: true,
        loadingComponent: null,

        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    created() {
      this.init();

    },
    mounted() {
      // this.loadingComponent = this.$loading.open({
      //               container: this.$refs.loadingElement.$el
      //           });
    },
    computed: {
      filteredData: function() {
        return this.all_customer.filter(customer => {
          return (
                  (customer.type && customer.type.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (customer.address && customer.address.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (customer.phone && customer.phone.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (customer.email && customer.email.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (customer.name && customer.name.toLowerCase().includes(this.search_query.toLowerCase()))

                )
        })
      }
    },
    methods: {
      selected(item) {
        if(!this.can("view_customer")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/customer/view/'+item.id })
        }
        this.lastSelected = item;
      },
      init() {
        this.isLoading = true;
        Request.get('customer',(res) => {
          // this.loadingComponent.close();
          this.isLoading = false;
          if(res.data.status){
            this.all_customer = res.data.data;
          }
        });
      },
      onPageChange(page){
        this.scrollTo({ 
          to: 'body'
        });
      }
    }
  }

</script>

<style lang="scss">
  table tbody {
    tr:hover {
      background-color: #F7F7F7;
    }
    .is-selected {
      cursor: pointer;
    }
  }

 

</style>



// WEBPACK FOOTER //
// src/pages/Customer/index.vue